import React, { useEffect, useMemo, useState } from "react";
// import card_image from "../../assets/card_image.png";
import { HiDotsVertical, HiLocationMarker } from "react-icons/hi";
import { IoCheckmark, IoNavigateSharp, IoShareSocial } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  
} from "reactstrap";
// import { FaPlus } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
// import Category from "../Home/Category";
import { hideLoader, showLoader } from "../../utils/action/Action";
import {
  placesByCategory,
  tzadikimCategory,
} from "../../services/category.service";
import { toast } from "react-toastify";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";

import NoDataFound from "../../components/NoDataFound/NoDataFound";
import { API_URL } from "../../config/config";
import { categoryItems } from "../AddMorePointsToRoute/AddMorePointsToRoute";
// import filter_icon from "../../assets/filter_icon.svg";
import {
  MdArrowBack,
  MdOutlineFeedback,
  MdOutlineNavigateNext,
} from "react-icons/md";
import { GoHome, GoPlus } from "react-icons/go";
import ContainerLayout from "../../layout/ContainerLayout";
import ShareModal from "../../components/Modals/ShareModal";
import { updateRouteDetail } from "../../services/myRoute.service";
import swal from "sweetalert";
import { IoIosSearch } from "react-icons/io";
import useDebounce from "../../components/Debounce/Debounce";
import Pagination from "../../components/Pagination/Pagination";

const AddMorePointsToRouteDetails = ({ isUserLoggedIn }) => {
  const location = useLocation();
  const state = location.state || {};

  const navigate = useNavigate();

  let categoryName = location?.state?.categoryName || "";
  const { categoryTitle } = location?.state || "";
  // const { categoryIcon } = location?.state || "";

  // const [viewName, setViewname] = useState("grid");
  const [categoryItem, setCategoryItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(200);
  const [totalCount, setTotalCount] = useState();
  const [totalRecords, setTotalRecords] = useState("");

  // const [checkForFavorite, setCheckForFavorite] = useState(null);
  const [debouceValue, setDebouceValue] = useState("");
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [mkmID, setMkmId] = useState();
  const [showReportModal, setShowReportModal] = useState(false);
  // const [routeName, setRouteName] = useState(null);
  const [pointName, setPointName] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [link, setLink] = useState("");
  const [routePoint, setRoutePoint] = useState(state.previousPageData[0].arr);

  console.log("catttttttttttttttt", categoryName);

  // let card_checked = false;
  const debounce = useDebounce();

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    search: "",
  });

  console.log("table data3", location.state.categoryName);

  console.log("cccccccccccccc", location?.state?.categoryName);
  const email = useSelector(
    (state) => state?.userDetailReducer?.userData?.email
  );

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    if (values?.search?.length > 0) {
      if (values?.search?.length > 2) {
        categoryName === "Tzadikim" ? tzadikimPlace() : places();
        categoryName === undefined ? tzadikimPlace() : places();
      } else {
        toast.info("Please enter atleast 3 characters to get result.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    } else {
      if (categoryTitle === "צדיקים" || categoryTitle === undefined) {
        tzadikimPlace();
      } else {
        places();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouceValue, currentPage, pageSize]);

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const places = async () => {
    if (categoryName === "Historical Places") {
      categoryName = "historical";
    } else if (categoryName === "Hotels") {
      categoryName = "motels";
    } else if (categoryName === "Synagogues") {
      categoryName = "synagogues";
    }

    try {
      dispatch(showLoader());
      const response = await placesByCategory(
        {
          Category: categoryName,
          Filter: values?.search?.trim(),
          email: email,
          checkForFavorite: true,
        },
        {
          pageNumber: currentPage,
          pageSize: 84,
        }
      );

      if (response && response?.status === 200) {
        setCategoryItem(response?.data?.data?.data);
        setCurrentPage(response?.data?.data?.pageNumber);
        setPageSize(pageSize);
        setTotalCount(response?.data?.data?.totalCount);
        dispatch(hideLoader());
      }
    } catch {
      dispatch(hideLoader());
    }
  };

  const addToRoute = (id) => {
    console.log("inside add tot 1 ", id);
    console.log("Previous Page Data:", state.previousPageData[0]?.key); // from Page 1
    console.log("Category Data:", state.categoryData); // from Page 2

    if (state.previousPageData[0]?.key === "addPointAbove") {
      addPointAbove(id);

      console.log("routePoint", state.previousPageData[0]?.key);
    } else if (state.previousPageData[0]?.key === "addPoints") {
      addPointInLast(id);
      console.log("routePoint", state.previousPageData[0]?.key);
    } else {
      setMkmId(id);
      console.log("inside add tot 2 ", id);
      console.log("inside add tot key", location?.state?.data?.key);
      addPointAbove(id);
    }
  };

  const addPointAbove = async (id) => {
    if (isUserLoggedIn) {
      const arr = location?.state?.data;

      if (arr?.length < 25) {
        const index = location?.state?.data?.index;
        let requestBody = [];
        arr?.splice(index, 0, {
          mkmID: id,
          orderNumber: 0,
          visited: false,
        });
        requestBody = arr?.map((item, i) => {
          return {
            mkmID: item?.place?.mkmID || item?.mkmID,
            orderNumber: i,
            visited: item?.visited,
          };
        });

        try {
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: location?.state?.data?.route_id,
          });
          console.log("res", res);
          if (res && res?.status === 200) {
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });

            setRoutePoint(res?.data);
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      } else {
        toast.warning(
          "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this point in your Route?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const addPointInLast = async (id) => {
    if (isUserLoggedIn) {
      const arr = state.previousPageData[0].arr;
      console.log("====================================");
      console.log("arrrrrrrr1", arr);
      console.log("====================================");
      if (arr?.length < 25) {
        let index = location?.state?.data?.index;
        index = arr.length;
        let requestBody = [];
        arr?.splice(index, 0, {
          mkmID: id,
          orderNumber: 0,
          visited: false,
        });
        requestBody = arr?.map((item, i) => {
          return {
            mkmID: item?.place?.mkmID || item?.mkmID,
            orderNumber: i,
            visited: item?.visited,
          };
        });

        try {
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: state.previousPageData[0].route_id,
          });

          if (res && res?.status === 200) {
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            console.log("res", res);
            setRoutePoint(res?.data?.data);
            console.log("====================================");
            console.log("rrrrrrrrr", routePoint);
            console.log("====================================");
            console.log(res?.data?.data);
            console.log("====================================");
            console.log("====================================");
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      } else {
        toast.warning(
          "Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this point in your Route?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const share = (id, poi) => {
    var data;
    data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
    setLink(data);

    setShowShareModal(true);
  };
  const tzadikimPlace = async () => {
    dispatch(showLoader());
    try {
      setCategoryItem([]);
      const response = await tzadikimCategory(
        {
          Category: "Tzadikim",
          Filter: values?.search,
          email: email,
          checkForFavorite: true,
        },
        {
          pageNumber: currentPage,
          pageSize: pageSize,
        }
      );
      if (response && response?.status === 200) {
        setCategoryItem(response?.data?.data?.data);
        setCurrentPage(response?.data?.data?.pageNumber);
        setPageSize(pageSize);
        setTotalCount(response?.data?.data?.totalCount);
      }
      dispatch(hideLoader());
    } catch {
      dispatch(hideLoader());
      setCategoryItem([]);
    }
  };

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    console.log("first last...", firstPageIndex, lastPageIndex, categoryItem);
    // return categoryItem?.slice(firstPageIndex, lastPageIndex);
    return categoryItem;
  }, [currentPage, categoryItem, pageSize]);

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  console.log("all dataaaa", categoryItem);

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const handleChange = (e) => {
    const newData = { ...values };
    newData[e?.target?.id] = e?.target?.value?.trim().replace(regex, "");
    setValues(newData);
    debounce(() => setDebouceValue(newData));
  };

  useEffect(() => {
    setTotalRecords(totalCount);
  }, [totalCount]);

  return (
    <div className="main_section add_points_route">
      <>
        <ReportSuggestionModal
          showReportModal={showReportModal}
          setShowReportModal={setShowReportModal}
          // setRouteName={setRouteName}
          pointName={pointName}
          mkmID={mkmID}
        />
        <ShareModal
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          link={link}
          setLink={setLink}
        />
        <Container>
          <div className="breadcrumb_section">
            <Breadcrumb className="breadcrumb">
              <BreadcrumbItem>
                <Link to="/" className="breadcrumb_item1">
                  <GoHome />
                </Link>
                <span className="breadcrumb-divider">
                  <MdOutlineNavigateNext />
                </span>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to="/my-routes" className="breadcrumb_item1">
                  My Routes
                </Link>
                <span className="breadcrumb-divider">
                  <MdOutlineNavigateNext />
                </span>
              </BreadcrumbItem>
              {/* <BreadcrumbItem>
                <Link to="/my-routes" className="breadcrumb_item1">
                  [Route Name]
                </Link>
                <span className="breadcrumb-divider">
                  <MdOutlineNavigateNext />
                </span>
              </BreadcrumbItem> */}
              {/* <BreadcrumbItem>
                            <Link to="/my-routes-detail" className="breadcrumb_item2">Details</Link>
                        </BreadcrumbItem> */}
              <BreadcrumbItem active>
                <Link to="#" className="breadcrumb_item2">
                  Add Points
                </Link>
              </BreadcrumbItem>
            </Breadcrumb>
          </div>
        </Container>
        <div className="add_points_section">
          <ContainerLayout classes={{ maxWidth: "1300px" }}>
            <div className="add_points_box">
              <div className="add_points_box_header_top">
                <div className="add_points_box_header_top">
                  <div className="add_points_box_header">
                    <div className="back-button">
                      <button
                        onClick={() =>
                          (window.location.href = "/add-more-points-to-route/")
                        }
                      >
                        <MdArrowBack />
                        <span>Back</span>
                      </button>
                    </div>

                    <div className="search_input">
                      <IoIosSearch className="icon" />
                      <Input
                        type="search"
                        id="search"
                        name="search"
                        value={values?.search}
                        onChange={handleChange}
                        maxLength="100"
                        placeholder="Search for a place?"
                        autoComplete="off"
                      />
                    </div>
                    {/* <div className="dropdown">
                      <Dropdown
                        className="addMorePoints_dropdown"
                        toggle={() => {
                          setOpen(!dropdownOpen);
                        }}
                        isOpen={dropdownOpen}
                      >
                        <DropdownToggle caret>{dropDownValue}</DropdownToggle>
                        <DropdownMenu>
                          {categoryItems?.map((item) => {
                            return (
                              <DropdownItem
                                key={item?.id}
                                onClick={(e) =>
                                  changeValue(
                                    e,
                                    item?.title + " / " + item?.showTitle
                                  )
                                }
                                value={item?.title + " / " + item?.showTitle}
                              >
                                {item?.title + " / " + item?.showTitle}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>
                      </Dropdown>
                    </div> */}
                  </div>
                  <h4 className="category_title">{categoryTitle}</h4>
                </div>
                <div className="item_card">
                  {currentTableData?.length === 0 ||
                  currentTableData === undefined ? (
                    <NoDataFound />
                  ) : (
                    currentTableData?.map((place, index) => (
                      <div
                        className="nt-card"
                        onClick={() => {
                          if (categoryName === "Tzadikim") {
                            navigate(
                              `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`,
                              {
                                state: {
                                  from: "addMorePointToRoute",
                                  data: location?.state?.data,
                                  categoryName: "tzadikim",
                                },
                              }
                            );
                          } else {
                            navigate(
                              `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`,
                              {
                                state: {
                                  from: "addMorePointToRoute",
                                  data: location?.state?.data,
                                  categoryName: categoryName,
                                },
                              }
                            );
                          }
                        }}
                      >
                        <div className="nt-card-image">
                          <img
                            src={
                              place?.imageIDs?.length > 0
                                ? `${API_URL}/api/mkm/getimage/${place?.imageIDs?.[0]}`
                                : categoryItems.find(
                                    (item) => item.showTitle === categoryTitle
                                  )?.icon
                            }
                            alt="placeholder"
                          />
                        </div>

                        <div className="nt-dropdown_list">
                          <Dropdown
                            className="nt-moreInfo"
                            toggle={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setMenuOpen(
                                index === dropdownMenuOpen ? null : index
                              );
                            }}
                            isOpen={index === dropdownMenuOpen}
                          >
                            <DropdownToggle
                              className="nt-list_icon"
                              caret={false}
                            >
                              <HiDotsVertical className="nt-list" />
                            </DropdownToggle>

                            <DropdownMenu
                              className="nt-custom_dropdown"
                              modifiers={[
                                {
                                  name: "offset",
                                  options: {
                                    offset: [-155, 5],
                                  },
                                },
                              ]}
                            >
                              <DropdownItem>
                                <Link
                                  to={`/along-the-way-to-here/${place?.poi}`}
                                  state={{
                                    from: "addMorePointToRoute",
                                    data: location?.state?.data,
                                  }}
                                  className="breadcrumb_item1 hello"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <IoNavigateSharp
                                    className="navigate_icon"
                                    size={"18px"}
                                  />
                                  Along the way to here
                                </Link>
                              </DropdownItem>

                              <DropdownItem
                                className="nt-report-suggestion"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  reportSuggestion(
                                    place?.title,
                                    place?.tzadikimID
                                      ? place?.tzadikimID
                                      : place?.mkmID
                                  );
                                }}
                              >
                                <MdOutlineFeedback size={17} />
                                Report suggestion
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>

                        <div className="nt-card-details">
                          <div
                            className="nt-share-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              share(
                                place?.tzadikimID
                                  ? place?.tzadikimID
                                  : place?.mkmID,
                                place?.poi
                              );
                            }}
                          >
                            <IoShareSocial />
                          </div>

                          <div className="nt-title">
                            {categoryName === "Tzadikim" ? (
                              <h3>
                                <Link
                                  to={`/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`}
                                  state={{
                                    from: "addMorePointToRoute",
                                    data: location?.state?.data,
                                    categoryName: "tzadikim",
                                  }}
                                  title={place?.title}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {place?.title}
                                </Link>
                              </h3>
                            ) : (
                              <h3>
                                <Link
                                  to={`/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`}
                                  state={{
                                    from: "addMorePointToRoute",
                                    data: location?.state?.data,
                                    categoryName: categoryName,
                                  }}
                                  tag="h5"
                                  title={place?.title}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {place?.title}
                                </Link>
                              </h3>
                            )}

                            <h4>
                              {place?.cityY
                                ? place?.cityY.substring(
                                    place?.cityY.indexOf("/") + 1
                                  )
                                : null}
                              {place?.stateY
                                ? " - " +
                                  place?.stateY.substring(
                                    place?.stateY.indexOf("/") + 1
                                  )
                                : null}
                            </h4>
                          </div>
                        </div>

                        <div className="nt-card-footer">
                          <div className="nt-card_footer-left-side">
                            <div className="nt-location">
                              <HiLocationMarker color="#618FFB" size={20} />
                              <span> {place?.cityE + " " + place?.stateE}</span>
                            </div>
                            <button
                              className="nt-btn-learn-more"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Link to="##">Learn More</Link>
                            </button>
                          </div>

                          <div className="nt-add_fav">
                            {routePoint.filter(
                              (item) =>
                                item?.place?.mkmID === place?.mkmID ||
                                item.mkmID === place?.mkmID
                            ).length > 0 ? (
                              <button
                                className="add-toRoute"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <IoCheckmark />
                              </button>
                            ) : (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  addToRoute(place?.mkmID);
                                }}
                              >
                                <GoPlus size={30} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {currentTableData?.length === 0 ||
                currentTableData === undefined ? null : (
                  <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={totalRecords > 0 ? totalRecords : null}
                    pageSize={pageSize}
                    onPageChange={(currentPage) => setCurrentPage(currentPage)}
                  />
                )}
              </div>
            </div>
          </ContainerLayout>
        </div>
      </>
    </div>
  );
};

export default AddMorePointsToRouteDetails;
